<template>
    <div>
        <v-layout row align-center mb-4>
            <v-flex lg5 md4 sm2
                    xs5 justify-end
                    class="mr-3"
            ><span v-if="test_started || test_finished || resultsLayout">{{$t("Результат итогового теста")}} </span><span v-else>{{$t("Пройдено разделов")}}</span> <br>
                {{ if_course_completed }} {{ $t("из") }} {{ test_started || test_finished || resultsLayout ? points_total_test : lessons_total }}
            </v-flex>
            <v-flex md3 lg3 xs4
                    mr-2
            >
                <v-progress-circular
                    :rotate="-90"
                    :size="64"
                    :width="6"
                    :value="test_started || test_finished || resultsLayout ? percent(if_course_completed, points_total_test) : percent(lessons_passed, lessons_total)"
                    :class="progressClass()"
                >
                    {{ test_started || test_finished || resultsLayout ? percent(if_course_completed, points_total_test) : percent(lessons_passed, lessons_total) }}%
                </v-progress-circular>
            </v-flex>
        </v-layout>
        <v-flex class="grey-text mb-4"><slot></slot></v-flex>
    </div>
</template>

<script>
import {mapGetters} from 'vuex';
export default {
  computed: {
    ...mapGetters('course_info', [
      'course_completed',
      'test_finished',
      'current_lesson',
      'lessons_passed',
      'points_required_test',
      'points_total_test',
      'points_earned_test',
      'time_test',
      'test_started',
      'test_remain_in_seconds',
    ]),
    ...mapGetters('testing/questions', [
      'question_number',
      'questions',
      'question_by_number',
      'questions_length',
      'stats',
    ]),
    ...mapGetters('testing', [
      'resultsLayout',
      'test_layout',
    ]),
    ...mapGetters('course_info/steps', [
      'lessons_total',
      'blocks',
      'items_for_block',
      'current_block',
    ]),
    if_course_completed: function() {
      if (this.test_started || this.test_finished || this.resultsLayout) {
        if (!this.resultsLayout && (this.test_layout || (this.test_started && !this.test_layout && !this.test_finished))) {
          return 0;
        } else {
          return this.points_earned_test;
        }
      } else {
        return this.lessons_passed;
      }
    },
  },
  methods: {
    percent: function(points, total) {
      if (points<total) {
        return Math.round((points/total)*100, 0);
      } else return 100;
    },
    progressClass: function() {
      if (this.course_completed) {
        if (this.points_earned_test >= this.points_required_test) {
          return 'green-text';
        } else {
          return 'red-text';
        }
      } else if (this.current_lesson >= this.lessons_total.length) {
        return 'green-text';
      } else {
        return 'red-text';
      }
    },
  },
};
</script>
